<template>
<div class="container">
    <div class="fenlei">
        <ul>
            <div v-for="(item,index) in typeLink" :key="index">
                <li v-if="typeId == -2" @click="getTypeSearch(item.listType,item.typeId)" :class="listType == item.listType?'on':''">{{item.typeName}}</li>
                <li v-else @click="getTypeSearch(item.listType,item.typeId)" :class="typeId == item.typeId? 'on':''">{{item.typeName}}</li>
            </div>
            <li @click="getTypeSearch(3,-2)" :class="listType == 3 && typeId == -2 ?'on':''">名师讲堂</li>
        </ul>
    </div>
    <h4>听历史选集</h4>
    <div v-if="typeId == 12 && listType==2" class="history-set">
        <div v-for="item in historyBookSet" :key="item.key">
            <span @click="setDetail(item.key)" :class="item.key==setkey?'active':''">{{item.value}}</span>
        </div>
        <button class="play-all" @click="playAll">▶ 播放当前选集</button>
    </div>
    <div v-for="item in typeSearch" :key="item.index">
        <div v-if="typeId == -2">
            <book-list-item v-bind:books="item"></book-list-item>
        </div>
        <div v-else>
            <book-item v-bind:books="item"></book-item>
        </div>
    </div>
    <div class="more"><button @click="getMore()" v-if="showMore">当前已加载{{pageIndex+1}}页，点击加载第{{pageIndex+2}}页</button> </div>
</div>
</template>

<script>
var searchList = [];
import BookItem from '@/components/BookItem'
import BookListItem from '@/components/BookListItem'
// @ is an alias to /src 

export default {
    metaInfo() {
        return {
            title: '路上畅听分类选书' + this.$store.state.title,
            meta: [{
                    vmid: 'keywords',
                    name: 'keywords',
                    content: this.$store.state.keywords
                },
                {
                    vmid: 'description',
                    name: 'description',
                    content: this.$store.state.description
                }
            ]
        }
    },
    data() {
        return {
            typeLink: {},
            pageIndex: 0,
            listType: 2,
            typeId: -2,
            apiurl: '/xcx/search',
            showMore: true,
            typeSearch: {},
            historyBookSet: [],
            setkey:0
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.typeId = this.$route.query.id;
        }
        if (this.$route.query.listType) {
            this.listType = this.$route.query.listType;

        }
        if (this.$route.query.typeId) {
            this.listType = 0;
            this.typeId = this.$route.query.typeId
        }
        this.getTypeLink()
        this.getTypeSearch(this.ListType, this.typeId);
        this.getBookSet()
    },
    methods: {
        getTypeLink: function () {
            this.$http.get({
                url: 'xcx/all-type-list'
            }).then(res => {
                this.typeLink = res.data.data;
                //this.$store.state.typeLink = res.data.data
                //console.log(res.data.data)

            })
        },
        getMore: function () {
            this.pageIndex++;
            this.getTypeSearch();
        },
        getTypeSearch: function (listType, atype) {

            if (atype) {
                this.pageIndex = 0;
                this.showMore = true;
                this.typeId = atype;
                searchList = [];
            }
            if (listType) {
                this.pageIndex = 0;
                this.showMore = true;
                this.listType = listType;
                searchList = [];
            }
            if (atype == -2) {
                this.apiurl = '/xcx/book-list';
            }
            if (listType == 0) {
                this.apiurl = '/xcx/search';
            }
            this.$http.get({
                url: this.apiurl + '?listType=' + this.listType + '&typeId=' + this.typeId + '&pageSize=90' + '&pageIndex=' + this.pageIndex
            }).then(res => {
                if (res.data.data.length == 0) {
                    this.showMore = false;
                    return
                }
                var i;
                for (i in res.data.data) {
                    searchList.push(res.data.data[i]);
                }
                this.typeSearch = searchList;
            })
        },
        getBookSet: function () {
            this.$http.get({
                url: '/xcx/history-book-sets'
            }).then(res => {
                if (res.data.data) {
                    this.historyBookSet = res.data.data
                }
            })
        },
        setDetail:function(setkey){
            this.$http.get({url:'/xcx/history-book-set-detail?typeId=12&setKey='+setkey}).then(res=>{
                this.typeSearch = res.data.data;
                this.setkey =setkey
            })
        },
        playAll:function(){ 
            this.$store.dispatch('playbooklist', this.typeSearch) 
        }, 
    },
    name: 'Library',
    components: {
        BookItem,
        BookListItem,
    }
}
</script>

<style scoped>
.fenlei {
    background-color: #f9f9f9;
    color: #434946;
    font-size: 14px;
    overflow: hidden;
    padding: 20px;
}

.fenlei ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.fenlei li {
    width: 141px;
    padding: 10px 0;
    font-weight: 600;
    background: #fff;
    overflow: hidden;
    float: left;
    text-align: center;
    margin: 12px 5px;
    border: 1px;
    border-radius: 3px;
    box-shadow: 1px 1px 3px #d5d5d5;
    cursor: pointer;
}

.fenlei li:hover,
.on {
    background-color: #4bcdab !important;
    color: #f9f9f9;
}

.booklist {
    padding: 30px 0;
}

.more {
    clear: both;
    text-align: center;
    padding: 30px 0;
}

.more button {
    color: rgba(75, 204, 170, 1);
    background: none;
    padding: 5px 10px;
    border: 1px solid rgba(75, 204, 170, 1);
    border-radius: 3px;
    cursor: pointer;
}

.more button:hover {
    background: #4bcdab;
    color: #fff;
}
.history-set{width: 100%; overflow: hidden;}
.history-set span{padding: 5px 10px; margin: 4px; float: left; color: #4bcdab; border: 1px solid #4bcdab; border-radius: 3px; cursor: pointer;}
.history-set span:hover, .active{background: #4bcdab; color: #fff !important;}
.play-all{float: right; background: #4CCCAA; color: #FFFFFF; border: none; padding: 5px 20px; border-radius: 3px; margin: 4px;}
.play-all:hover{background: rgb(23, 196, 150);}
</style>
